import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { ArrowRightIcon } from '@fiverr-private/icons';
import { track as mixpanelTrack } from '../../../lib/mixpanel';
import { AFFILIATE_LINKS } from '../../../constants';
import { useUser } from '../../hooks/useUser';

export const Affiliate = () => {
  const user = useUser();
  const isGuest = !user;

  const affiliateLink = isGuest ? AFFILIATE_LINKS.GUEST : AFFILIATE_LINKS.USER;

  const onAffiliateClick = () => {
    mixpanelTrack('Referral Page Inviter - Affiliate Link - Click');
  };

  return (
    <Stack as="section" justifyContent="center" data-testid="affiliate" backgroundColor="orange_100">
      <Stack
        width="100%"
        direction={{ default: 'column', md: 'row' }}
        gap={{ default: '6', sm: '8', md: '12' }}
        paddingX={{ default: '6', sm: '8', md: '12', xl: '0' }}
        paddingY={{ default: '10', md: '12', xl: '16' }}
        maxWidth={{ lg: '1400px' }}
      >
        <Stack flex="1">
          <h2>
            <I18n k="referral_program_perseus.affiliate.title" />
          </h2>
        </Stack>
        <Stack flex="1" direction="column" justifyContent="flexStart" alignItems="flexStart">
          <Text color="bodySecondary" marginBottom="8">
            <I18n k="referral_program_perseus.affiliate.text" />
          </Text>
          <Button onClick={onAffiliateClick} href={affiliateLink} target="_blank" intent="primary" variant="ghost">
            <I18n k="referral_program_perseus.affiliate.cta" />
            <ArrowRightIcon />
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
